import createNetworkingClient from 'utils/networking-client';
import { StatusCodes } from 'http-status-codes';
import PERMISSIONS from '../../constants/consents/permissionTypes';
import { isConsentsCreateAction } from '../../apps/Onboarding/shared/onboardingUtils';
import { logError } from '../../utils/sentry';

export const completeProfile = ({ data }) => {
  return new Promise((resolve, reject) => {
    const url = '/onboarding/complete_profile';

    const payload = {
      ...data,
      // react_onboarding flag is used by the api endpoint to determine the correct response
      // data for this XHR call
      react_onboarding: true
    };

    createNetworkingClient()
      .post(url, payload, { headers: { Accept: 'text/javascript' } })
      .then((response) => {
        if (response?.status === StatusCodes.OK) {
          resolve(response.data);
        } else {
          logError(response.error);
          reject(response.error);
        }
      })
      .catch((e) => {
        logError(e);
        reject(e);
      });
  });
};

export const facebookFriendsNextStep = () => {
  return new Promise((resolve, reject) => {
    createNetworkingClient()
      .get('/onboarding/facebook_friends_next_step')
      .then((response) => {
        if (response?.status === StatusCodes.OK) {
          resolve(response.data);
        } else {
          logError(response.error);
          reject(response.error);
        }
      })
      .catch((e) => {
        logError(e);
        reject(e);
      });
  });
};

// action - denied or approved
export const postDirectPromotionConsent = ({ action, currentStep }) => {
  return new Promise((resolve, reject) => {
    if (isConsentsCreateAction(action)) {
      const url = '/onboarding/consents';

      const payload = {
        consent: action,
        permission_type: PERMISSIONS.directPromotion,
        // react_onboarding flag is used by the api endpoint to determine the correct response
        // data for this XHR call
        react_onboarding: true,
        current_step: currentStep
      };

      createNetworkingClient()
        .post(url, payload, { headers: { Accept: 'text/javascript' } })
        .then((response) => {
          if (response?.status === StatusCodes.OK) {
            resolve(response.data);
          } else {
            logError(response.error);
            reject(response.error);
          }
        })
        .catch((e) => {
          logError(e);
          reject(e);
        });
    } else {
      reject(new Error(`incompatible action type - ${action}`));
    }
  });
};

/**
 *
 * Makes a GET XHR call to retrieve next steps if the current step does not update permissions.
 *
 * Makes a POST XHR call to create new permissions and responds with the next step when the current
 * step updates permissions.
 *
 * @param {Object} arg
 * @param {string} arg.step - one of onboardingConstants.REGISTRATION_FLOW or onboardingConstants.CONSENTS_FLOW
 * @param {string} arg.action - one of ActionButton.ACTIONS
 * @param {string} arg.permissionType - one of permissionTypes.PERMISSION_TYPES
 * @returns {Object} response
 * @returns {boolean} response.nextStep - next step
 * */
export const existingAthleteFlowNextStep = ({
  step,
  action,
  permissionType
}) => {
  return new Promise((resolve, reject) => {
    const url = '/athlete/consents/next_step';
    let params = {
      id: step
    };
    let method = 'GET';
    let data = {};

    if (isConsentsCreateAction(action)) {
      method = 'POST';
      params = {};
      data = {
        id: step,
        permission_type: permissionType,
        consent: action
      };
    }

    createNetworkingClient()
      .request({
        method,
        url,
        params,
        data
      })
      .then((response) => {
        if (response?.status === StatusCodes.OK) {
          resolve(response.data);
        } else {
          logError(response.error);
          reject(response.error);
        }
      })
      .catch((e) => {
        logError(e);
        reject(e);
      });
  });
};

export default {
  completeProfile,
  facebookFriendsNextStep,
  postDirectPromotionConsent,
  existingAthleteFlowNextStep
};
